import { styled } from '@clickcease/cc-client-components-lib'

export const PricingStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const BackToDashboard = styled('div', {
  cursor: 'pointer',
  fontSize: '$md',
  margin: '$10 0px 0px $4',

  '> svg': {
    marginRight: '$3',
  },
})

export const PricingWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '287px',
  background: '#EEF1FA',
  alignItems: 'center',

  '@bp1': {
    width: '100%',
    height: '165px',
  },
})

export const PricingHeaderInner = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '615px',
  textAlign: 'center',

  '@bp1': {
    width: '100%',
  },
})

export const PricingTitle = styled('div', {
  fontSize: '40px',
  fontWeight: '$b',
  marginTop: '22px',
  '@bp1': {
    fontSize: '$h1',
    marginTop: '5px',
    lineHeight: ' 33px',
    width: '56%',
  },
})

export const TabsWrapper = styled('div', {
  marginTop: '59px',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',

  '> div': {
    width: '100%',
  },

  '[role="tablist"]': {
    justifyContent: 'center',
  },

  '@bp1': {
    marginTop: '$10',
  },
})

export const TopRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 $12',
  width: 'calc(100% -  48px)',
})

export const RightSideWrapper = styled('div', {
  display: 'flex',
})
